import { Box } from '@chakra-ui/react';
import SadhGuruLiveCard from '@in-person/Components/Cards/SadhGuruLiveCard.js';
import { nanoid } from 'nanoid';

const SadhguruLiveSection = ({ sectionContent, region, lang, pageData }) => {
  return (
    <Box
      px={{ base: '15px', lg: '0px' }}
      width="100%"
      maxW={{ md: '1030px' }}
      id="sadhguru-live"
      mx="auto"
    >
      <Box background={'#FFE6B4'}>
        <SadhGuruLiveCard
          card={sectionContent[1]?.cards[0]}
          lang={lang}
          region={region}
          key={nanoid()}
          pageData={pageData}
        />
      </Box>
    </Box>
  );
};

export default SadhguruLiveSection;
